import { COLORS } from '@/styles/colorTheme';
import { FileChartPie } from 'lucide-react';

const AnalysisIcon = ({ state = 'mouseup', isSelected = false }) => {
  let color = COLORS.Text400;
  if (state === 'mousedown') color = '#fff';

  return (
    <>
      <FileChartPie color={color} size={22} strokeWidth={1.5} />
    </>
  );
};

export default AnalysisIcon;
